import { Campaign3Wizard } from "./campaign-3-touchpoint.model";

export class JsonSchema{
  mode: string;
  title: string;
  description: string;
  type: string;
  properties: JsonSchemaProperties;

  constructor(){
    this.properties = new JsonSchemaProperties();
  }
}

export class JsonSchemaProperties{
  infoBase: JsonSchemaFormPropertiesForm;
  pianificazione: JsonSchemaFormPropertiesForm;
  tipoAzioni: JsonSchemaFormPropertiesForm;
  emissione: JsonSchemaFormPropertiesForm;
  fruizione: JsonSchemaFormPropertiesForm;
  customerTarget: JsonSchemaFormPropertiesForm;
  targetArticoli: JsonSchemaFormPropertiesForm;
  touchpoint: JsonSchemaFormPropertiesForm;

  constructor(){
    this.infoBase = new JsonSchemaFormPropertiesForm();
    this.pianificazione = new JsonSchemaFormPropertiesForm();
    this.tipoAzioni = new JsonSchemaFormPropertiesForm();
    this.emissione = new JsonSchemaFormPropertiesForm();
    this.fruizione = new JsonSchemaFormPropertiesForm();
    this.customerTarget = new JsonSchemaFormPropertiesForm();
    this.targetArticoli = new JsonSchemaFormPropertiesForm();
    this.touchpoint = new JsonSchemaFormPropertiesForm();
  }
}

export class JsonSchemaInfoBasePropertiesFormProperties{
  coupon_type: JsonSchemaPropertiesFormFieldsProperties;
  advantage_type: JsonSchemaPropertiesFormFieldsProperties;
  name: JsonSchemaPropertiesFormFieldsProperties;
  valore_coupon: JsonSchemaPropertiesFormFieldsProperties;
  int_code: JsonSchemaPropertiesFormFieldsProperties;
  public_description: JsonSchemaPropertiesFormFieldsProperties;
  int_note: JsonSchemaPropertiesFormFieldsProperties;

  constructor(){
    this.coupon_type = new JsonSchemaPropertiesFormFieldsProperties();
    this.advantage_type = new JsonSchemaPropertiesFormFieldsProperties();
    this.name = new JsonSchemaPropertiesFormFieldsProperties();
    this.valore_coupon = new JsonSchemaPropertiesFormFieldsProperties();
    this.int_code = new JsonSchemaPropertiesFormFieldsProperties();
    this.public_description = new JsonSchemaPropertiesFormFieldsProperties();
    this.int_note = new JsonSchemaPropertiesFormFieldsProperties();
  }
}




export class JsonSchemaTipoAzioniPropertiesFormProperties{
  clienti_destinati_promo: JsonSchemaPropertiesFormFieldsProperties;
  tipo_attuazione_promo: JsonSchemaPropertiesFormFieldsProperties;

  constructor(){
    this.clienti_destinati_promo = new JsonSchemaPropertiesFormFieldsProperties();
    this.tipo_attuazione_promo = new JsonSchemaPropertiesFormFieldsProperties();
  }
}


export class JsonSchemaTargetArticoliPropertiesFormProperties{
  tipo_entita_emissione: JsonSchemaPropertiesFormFieldsProperties;
  tipo_entita_fruizione: JsonSchemaPropertiesFormFieldsProperties;

  constructor(){
    this.tipo_entita_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.tipo_entita_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
  }
}

export class JsonSchemaFormPropertiesForm{
  formName: string;
  id: string;
  description: string;
  form: object;

  constructor(){
    this.form = {}
  }
}

export class JsonSchemaEmissionePropertiesFormProperties {
  tipo_soglia_emissione: JsonSchemaPropertiesFormFieldsProperties;
  soglia_emissione_coupon: JsonSchemaPropertiesFormFieldsProperties;
  soglia_riemissione_coupon: JsonSchemaPropertiesFormFieldsProperties;
  numero_massimo_fruizioni_clienti: JsonSchemaPropertiesFormFieldsProperties;
  accumulatore_operazione: JsonSchemaPropertiesFormFieldsProperties;
  accumulatore_valore: JsonSchemaPropertiesFormFieldsProperties;
  articolo_coupon: JsonSchemaPropertiesFormFieldsProperties;
  barcode_coupon: JsonSchemaPropertiesFormFieldsProperties;
  solo_barcode: JsonSchemaPropertiesFormFieldsProperties;
  articolo_coupon_attivatore: JsonSchemaPropertiesFormFieldsProperties;
  barcode_coupon_attivatore: JsonSchemaPropertiesFormFieldsProperties;
  solo_barcode_attivatore: JsonSchemaPropertiesFormFieldsProperties;
  num_max_emissioni_totali: JsonSchemaPropertiesFormFieldsProperties;
  num_max_transazioni_emittenti_clienti: JsonSchemaPropertiesFormFieldsProperties;
  num_max_emissioni_cliente: JsonSchemaPropertiesFormFieldsProperties;

  //switch
  coupon_ripetibile: JsonSchemaPropertiesFormFieldsProperties;
  gestione_accumulatori: JsonSchemaPropertiesFormFieldsProperties;
  switch_barcode_attivatore: JsonSchemaPropertiesFormFieldsProperties;
  switch_limiti_emissione: JsonSchemaPropertiesFormFieldsProperties;
  //nuovi campi
   switch_gestione_accumulatori: JsonSchemaPropertiesFormFieldsProperties;
    accumulatori_operazione: JsonSchemaPropertiesFormFieldsProperties;
    accumulatori_regole_avanzate: JsonSchemaPropertiesFormFieldsProperties;
    accumulatore_regole_operatore :JsonSchemaPropertiesFormFieldsProperties;
    accumulatore_regole_valore: JsonSchemaPropertiesFormFieldsProperties;



  constructor() {
    this.tipo_soglia_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.soglia_emissione_coupon = new JsonSchemaPropertiesFormFieldsProperties();
    this.soglia_riemissione_coupon = new JsonSchemaPropertiesFormFieldsProperties();
    this.numero_massimo_fruizioni_clienti = new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatore_operazione = new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatore_valore = new JsonSchemaPropertiesFormFieldsProperties();
    this.articolo_coupon = new JsonSchemaPropertiesFormFieldsProperties();
    this.barcode_coupon = new JsonSchemaPropertiesFormFieldsProperties();
    this.solo_barcode = new JsonSchemaPropertiesFormFieldsProperties();
    this.articolo_coupon_attivatore = new JsonSchemaPropertiesFormFieldsProperties();
    this.barcode_coupon_attivatore = new JsonSchemaPropertiesFormFieldsProperties();
    this.solo_barcode_attivatore = new JsonSchemaPropertiesFormFieldsProperties();
    this.num_max_emissioni_totali = new JsonSchemaPropertiesFormFieldsProperties();
    this.num_max_transazioni_emittenti_clienti = new JsonSchemaPropertiesFormFieldsProperties();
    this.num_max_emissioni_cliente = new JsonSchemaPropertiesFormFieldsProperties();

    //switch
    this.coupon_ripetibile = new JsonSchemaPropertiesFormFieldsProperties();
    this.gestione_accumulatori = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_barcode_attivatore = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_limiti_emissione = new JsonSchemaPropertiesFormFieldsProperties();

       this.switch_gestione_accumulatori= new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatori_operazione= new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatori_regole_avanzate = new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatore_regole_operatore = new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatore_regole_valore = new JsonSchemaPropertiesFormFieldsProperties();
  }
}



export class JsonSchemaTouchpointPropertiesFormProperties {
  switch_offline_emissione: JsonSchemaPropertiesFormFieldsProperties;
  switch_online_emissione: JsonSchemaPropertiesFormFieldsProperties;
  switch_offline_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  switch_online_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  switch_offline_come_emissione: JsonSchemaPropertiesFormFieldsProperties;
  switch_online_come_emissione: JsonSchemaPropertiesFormFieldsProperties;
  wizard: JsonSchemaPropertiesFormFieldsProperties;

  constructor() {
    this.wizard = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_offline_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_online_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_offline_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_online_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_offline_come_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_online_come_emissione = new JsonSchemaPropertiesFormFieldsProperties();
  }
}

export class JsonSchemaFruizionePropertiesFormProperties {

  tipo_soglia_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  soglia_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  accumulatore_operazione: JsonSchemaPropertiesFormFieldsProperties;
  accumulatore_valore: JsonSchemaPropertiesFormFieldsProperties;
  numero_utilizzi: JsonSchemaPropertiesFormFieldsProperties;
  modalita_utilizzo: JsonSchemaPropertiesFormFieldsProperties;
  num_max_fruizioni_totali_cliente: JsonSchemaPropertiesFormFieldsProperties;
  num_max_transazioni_cliente: JsonSchemaPropertiesFormFieldsProperties;
  num_max_fruizioni_cliente_transazione: JsonSchemaPropertiesFormFieldsProperties;
  modo_calcolo_soglia: JsonSchemaPropertiesFormFieldsProperties;
  gestione_accumulatori: JsonSchemaPropertiesFormFieldsProperties;
  switch_limiti_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  accumulatori_operazione: JsonSchemaPropertiesFormFieldsProperties;
    accumulatori_regole_avanzate :  JsonSchemaPropertiesFormFieldsProperties;
    accumulatore_regole_operatore : JsonSchemaPropertiesFormFieldsProperties;
    accumulatore_regole_valore :  JsonSchemaPropertiesFormFieldsProperties;

  constructor() {
    this.tipo_soglia_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.soglia_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatore_operazione = new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatore_valore = new JsonSchemaPropertiesFormFieldsProperties();
    this.numero_utilizzi = new JsonSchemaPropertiesFormFieldsProperties();
    this.modalita_utilizzo = new JsonSchemaPropertiesFormFieldsProperties();
    this.num_max_fruizioni_totali_cliente = new JsonSchemaPropertiesFormFieldsProperties();
    this.num_max_transazioni_cliente = new JsonSchemaPropertiesFormFieldsProperties();
    this.num_max_fruizioni_cliente_transazione = new JsonSchemaPropertiesFormFieldsProperties();
    this.modo_calcolo_soglia = new JsonSchemaPropertiesFormFieldsProperties();
    this.gestione_accumulatori = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_limiti_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatori_operazione= new JsonSchemaPropertiesFormFieldsProperties();
      this.accumulatori_regole_avanzate = new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatore_regole_operatore = new JsonSchemaPropertiesFormFieldsProperties();
    this.accumulatore_regole_valore = new JsonSchemaPropertiesFormFieldsProperties();
  }
}




export class JsonSchemaPianificazionePropertiesFormProperties{
  data_inizio_emissione: JsonSchemaPropertiesFormFieldsProperties;
  data_fine_emissione: JsonSchemaPropertiesFormFieldsProperties;
  data_inizio_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  data_fine_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  modalita_inizio_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  modalita_fine_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  offset_inizio_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  offset_fine_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  giorno_settimana_inizio: JsonSchemaPropertiesFormFieldsProperties;
  giorno_settimana_fine: JsonSchemaPropertiesFormFieldsProperties;
  data_inizio_fruizione_fissa: JsonSchemaPropertiesFormFieldsProperties;
  data_fine_fruizione_fissa: JsonSchemaPropertiesFormFieldsProperties;

  /*** switch ***/
  come_campagna: JsonSchemaPropertiesFormFieldsProperties;
  come_emissione: JsonSchemaPropertiesFormFieldsProperties;
  variabili: JsonSchemaPropertiesFormFieldsProperties;

  constructor(){
    this.data_inizio_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.data_fine_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.data_inizio_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.data_fine_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.modalita_inizio_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.modalita_fine_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.offset_inizio_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.offset_fine_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.giorno_settimana_inizio = new JsonSchemaPropertiesFormFieldsProperties();
    this.giorno_settimana_fine = new JsonSchemaPropertiesFormFieldsProperties();
    this.data_inizio_fruizione_fissa = new JsonSchemaPropertiesFormFieldsProperties();
    this.data_fine_fruizione_fissa = new JsonSchemaPropertiesFormFieldsProperties();
    this.come_campagna = new JsonSchemaPropertiesFormFieldsProperties();
    this.come_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.variabili = new JsonSchemaPropertiesFormFieldsProperties();
  }
}


export class JsonSchemaCustomerTargetPropertiesFormProperties{
  switch_come_emissione: JsonSchemaPropertiesFormFieldsProperties;
  switch_carta_necessaria: JsonSchemaPropertiesFormFieldsProperties;
  lista_distribuzione_emissione: JsonSchemaPropertiesFormFieldsProperties;
  lista_distribuzione_fruizione: JsonSchemaPropertiesFormFieldsProperties;
  tipo_controllo: JsonSchemaPropertiesFormFieldsProperties;

  constructor(){
    this.switch_come_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.switch_carta_necessaria = new JsonSchemaPropertiesFormFieldsProperties();
    this.lista_distribuzione_emissione = new JsonSchemaPropertiesFormFieldsProperties();
    this.lista_distribuzione_fruizione = new JsonSchemaPropertiesFormFieldsProperties();
    this.tipo_controllo = new JsonSchemaPropertiesFormFieldsProperties();
  }
}

export class JsonSchemaPropertiesFormFieldsRadioOptions{
  name: string;
  value: any;
  label: JsonSchemaLabel;
  constructor(){
    this.label = new JsonSchemaLabel();
  }
}

export class JsonSchemaPropertiesFormFieldsProperties{
    fieldName: string;
    id: string;
    type: string;
    description: string;
    minValue: number;
    maxValue: number;
    default: string;
    maxLength: number;
    minLength: number;
    minDate: Date;
    maxDate: Date;
    required: boolean;
    pattern: string;
    disabled: boolean;
    radioOptions: Array<JsonSchemaPropertiesFormFieldsRadioOptions>
    options: Array<any>;
    optionLabel: string;
    label: JsonSchemaLabel;
    step: number;
    name: string;
    placeholder: string;
    visible: boolean;
    filterable: boolean;
    constructor(){
      this.radioOptions = new Array<JsonSchemaPropertiesFormFieldsRadioOptions>();
      this.options = new Array<any>();
      this.label = new JsonSchemaLabel();
    }
}

export class JsonSchemaLabel{
  it: string;
  en: string;
}


export class Campaign3Info{
  id: number;
  name: string;
  description: string;
  dateStart: Date;
  dateEnd: Date;
}


//CLASSI PER OGGETTONE CHE RAPPRESENTA L'AZIONE:

/*
export class MessageInstanceRuleDetail {
  id: number = null;
  messageInstanceRuleId: number = null;
  objectId: number = null;
  object: ObjectInfo = null;
  objectTypeId: number = null;
  objectType: ObjectType = null;
  objectInclude: string = null;
  flgState: string = null;
  flgKf: string = null;
  flgDpl: string = null;
  objectValue: string = null;
  objectJson: any = null; //da verificare e inserire il tipo giusto

  constructor(){
    this.object = new ObjectInfo();
    this.objectType = new ObjectType();
  }
}
*/



export class ObjectInfo {
  _Comment: string = null;
  name: string = null;
}

export class ObjectType {
  _Comment: string = null;
  code: string = null;
  name: string = null;
}


export class MessageInstanceRuleDetail {
  id: number = null;
  messageInstanceRuleId: number = null;
  description: string;
  objectId: number = null;   //???
  object: ObjectInfo = null;
  objectTypeCode: string = null;
  objectTypeId: number = null;  //id dei tipi PTRT, PTRE, JACR, JAAR, ecc...
  objectType: ObjectType = null;
  objectInclude: string = null; //"include" o "exclude" vale soltanto per la rule con code PT e conseguenti detail TBCD, TDEP, TCAT, TBSK, TPRD (con valori include, exclude corrispondente ad un checkbox ), il priority vale solo per i touchpoint rule OL e rule_detail TOCH
  objectValue: string = null;  //valore
  objectPriorty: number = null;  //???
  objectJson: AccumulatorDetail_JACR | AccumulatorDetail_JAAR | any = null; //oggetto da passare in caso di regole JACR, cioè fatto così:


  constructor(){
    this.object = new ObjectInfo();
    this.objectType = new ObjectType();
  }

}

//REGOLE MESSAGE INSTANCE
export class MessageInstanceRule {
  id: number = null;
  messageInstanceId: number = null; //ridondante?
  ruleTypeId: number = null; // tipo (LM AC BC BA...)
  ruleScope: string = null; // 'emission' o 'fruition'
  description: string = null; //che ci devo mettere?
  messageInstanceRuleDetail: MessageInstanceRuleDetail[] = null;
  ruleType: string = null;
  ochannelId?: number =null;    //riferimento in RT_rules per quale touchpoint
  touchpointTarget?:string=null //aggiunto per capire se ONLINE o OFFLINE

  constructor(){
  }
}

export class StoreMessageOChannel {
  id: number = null;
  messageInstanceId: number = null;
  ochannelId: number = null;
  storeId: number = null;
  storeGroupId: number = null;
  storeType: string = null; //E emission oppure F fruition
  flg_state: string = null;
  flg_kf: string = null;
  flg_dpl: string = null;
  visited: boolean = null;
}

export class MessageInstanceObject {
  actionType: string = null;
  id: number = null;
  messageId: number = null;
  code: string = null;
  name: string = null;
  description: string = null;
  discountAmt: number = null;
  couponUseNumber: number = null;
  couponUseType: string = null;
  totalCouponNumber: number = null;
  couponType: string = "S"; //non può essere null, o R (ripetibile) o S (singolo)
  couponAmt: number = null;
  notes: string = null;
  flgCardHolder: string = null;
  cardHolderType: string = null;
  thresholdValue: number = null;
  startFruitionDate: string = null;
  endFruitionDate: string = null;
  actualGeneratedCoupon: number = null;
  flgCouponingMethod: string = null;
  flgState: string = null;
  flgKf: string = null;
  flgDpl: string = null;
  productCodeGroupId: number = null;
  layoutDefaultFormSchema: any = null;
  layoutValue: any = null;
  flgPreview: string = null;
  targetLoyaltyClass: string = null;
  promoEmission: string = null;
  couponValidityDateStartMode: string = null;
  couponValidityDateStart: string = null;
  couponValidityStartOffsetDay: number = null;
  couponValidityStartWeekDay: number = null;
  couponValidityDateEndMode: string = null;
  couponValidityDateEnd: string = null;
  couponValidityEndOffsetDay: number = null;
  couponValidityEndWeekDay: number = null;
  flgRolling: string = "0"; //non può essere null
  startEmissionDate: string = null;
  endEmissionDate: string = null;
  campaignId: number = null;
  status: string = null; //code della tabella stati della messageInstance
  discountTypeId: number = null;
  discountType:string =null;
  messageInstanceRule: MessageInstanceRule[] = null;
  storeMessageOChannel: StoreMessageOChannel[] = null;

  constructor(){

  }

}

export class CampaignSingleObjectResponse {
  budget: number;
  budgetTypeId: number;
  campaignStatusId:number;
  campaignTypeDescription: string;
  campaignTypeId: number
  code: string;
  description:string;
  endDate: string;
  id: number;
  messageInstance: Array<MessageInstanceObject>;
  name: string;
  startDate: string;
}

export class ProductItemBarcodeResponse{
  product_id: number;
  product_code: string;
  product_description: string;
  barcode: string;
  product_variant: string;
  department_code: string;
  categorie: string;
  flg_state: string;
}


export class ProductItemComplete{
  id: number;
  code: string;
  host_code: string;
  short_description: string;
  sku: number;
  variant: string;
  description: string;
  product_category_id: number;
  product_department_id: number;
  product_code_group_id: number;
  product_item_type_pid: number;
  barcode: string;
  barcodes: Array<string>;
  product_department: string;
  product_categories: string;
  basket_name: string;
  basket_description: string;
  flg_state: string;
  flg_kf: string;
  flg_dpl: number;

  constructor(){
    this.barcodes = [];
  }
}

export class ArticoliDropdown{
  product_id: number;
  product_code: string;
  product_description: string;
  product_codeDescription: string;
  barcodes: Array<string>;
  product_variant: string;
  department_code: string;
  categorie: string;
  flg_state: string;

  constructor(){
    this.barcodes = [];
  }
}

export class MessageInstanceRuleTypes{
id:number;
code: string;
description: string
flg_dpl: string;
flg_kf: string;
flg_state: string;
}

export class MessageInstanceObjectTypes{
  id: number;
  name: string;
  code: string;
  flg_dpl: string;
  flg_kf: string;
  flg_state: string;
}


export class AccumulatorDetail_JACR{
  check: AccumulatorDetail_JACR_JAAR

  constructor(){
    this.check = new AccumulatorDetail_JACR_JAAR();
  }
}

export class AccumulatorDetail_JAAR{
  move: AccumulatorDetail_JACR_JAAR

  constructor(){
    this.move = new AccumulatorDetail_JACR_JAAR();
  }
}
export class AccumulatorDetail_JACR_JAAR{
  acm_code: string;
  acm_operation: string;
  acm_points: number;
  acm_reason_code: string;
  acm_id: number;
  koncentro?: boolean; 
  operator?: string;
}


export class ActionDetails{
  id: number;
  messageId: number;
  code: string;
  name: string;
  description: string;
  couponUseNumber: number;
  couponUseType: string;
  totalCouponNumber: number;
  couponType: string;
  couponAmt: number;
  notes: string;
  flgCardHolder: string;
  flgRolling: string;
  cardHolderType: string;
  thresholdValue: number;
  startFruitionDate: string;
  endFruitionDate: string;
  actualGeneratedCoupon: number;
  flgCouponingMethod: string;
  productCodeGroupId: number | null;
  layoutValue: any;
  flgPreview: string;
  targetLoyaltyClass: string;
  promoEmission: string;
  startEmissionDate: string;
  endEmissionDate: string;
  campaignId: number;
  status: string;
  discountTypeId: number;
  messageInstanceRule: Campaign3MessageInstanceRules[];
  storeMessageOChannel: any[]; // Consider defining a proper interface if possible
  couponValidityDateStartMode: any;
  couponValidityDateStart: any;
  couponValidityStartOffsetDay: any;
  couponValidityStartWeekDay: any;
  couponValidityDateEndMode: any;
  couponValidityDateEnd: any;
  couponValidityEndOffsetDay: any;
  couponValidityEndWeekDay: any;
  discountType: string;
  actionType: string;
  flg_state: string;
  flg_kf: string;
  flg_dpl: string;
  user_ins_id: number | null;
  ts_ins: string | null;
  user_upd_id: number | null;
  ts_upd: string | null;
  user_del_id: number | null;
  ts_del: string | null;
}

export class Campaign3MessageInstanceRules{
  //emissione
  CV_rules_emission: MessageInstanceRule;
  AC_rules_emission: MessageInstanceRule;
  BC_rules_emission: MessageInstanceRule;
  BA_rules_emission: MessageInstanceRule;
  LM_rules_emission: MessageInstanceRule;
  CT_rules_emission: MessageInstanceRule; //customer target
  PT_rules_emission: MessageInstanceRule; //products target
  OL_rules_emission: MessageInstanceRule; //touchpoint
  WZ_rules_emission: MessageInstanceRule; //touchpoint

  //fruizione
  CV_rules_fruition: MessageInstanceRule;
  AC_rules_fruition: MessageInstanceRule;
  LM_rules_fruition: MessageInstanceRule;
  CT_rules_fruition: MessageInstanceRule; //customer target
  PT_rules_fruition: MessageInstanceRule; //products targetù
  OL_rules_fruition: MessageInstanceRule; //touchpoint
  WZ_rules_fruition: MessageInstanceRule; //touchpoint

  TR_rules_fruition: MessageInstanceRule[]; //touchpoint ru
  TR_rules_emission: MessageInstanceRule[]; //touchpoint rules
}


export class OperazioneAccumulatoriDropdown{
  value: string;
  label: string;
}

export class RegolaAvanzata{
  id: number;
  value: string;
}

export class DistributionListCluster{
  distributionListId: number;
  distributionListName: string;
  clusterList: string;
  flg_state: string;
}

export class DistributionListDetails{
  customer_id: number;
  customer_host_host_id: string;
  card_no: string;
  telephone: string;
  cluster_head_code: string;
  flg_state: string;
}


export class DistributionList3{
  distributionListId: number;
  numOfClusters: number;
  numOfActions: number;
  distributionListName: string;
  distributionListDescription: string | null;
  lastModifyDate: string;
  flgPreview: string;
  flg_dpl: string;
  flg_kf: string;
  flg_state: string;
  user_ins_id: number;
  ts_ins: string;
  user_upd_id: number | null;
  ts_upd: string | null;
  user_del_id: number | null;
  ts_del: string | null;

}
export class DistributionCluster3{
  code: string | null;
  description: string;
  end_date: string;
  flg_dpl: boolean | null;
  flg_kf: boolean | null;
  flg_state: string;
  id: number;
  last_modify_date: string;
  start_date: string;
  ts_del: string | null;
  ts_ins: string | null;
  ts_upd: string | null;
  user_del_id: number | null;
  user_ins_id: number | null;
  user_upd_id: number | null;
}


export class DistributionPromo {
  action_type: string;
  action_type_id: number;
  actual_generated_coupon: number;
  campaign_color: string;
  campaign_id: number;
  campaign_name: string;
  campaign_type: string;
  code: string;
  color: string;
  coupon_validity_date_end_mode: string;
  coupon_validity_date_start_mode: string;
  end_emission_date: string;
  end_fruition_date: string;
  favourite: boolean;
  flg_dpl: boolean;
  flg_kf: boolean;
  flg_preview: boolean;
  flg_rolling: boolean;
  flg_state: string;
  id: number;
  name: string;
  notes: string;
  promo_emission: string;
  rule_scope: string;
  start_emission_date: string;
  start_fruition_date: string;
  status: string;
  target_loyalty_class: string;
  ts_del: string;
  ts_ins: string;
  ts_upd: string;
  user_del_id: number;
  user_ins_id: number;
  user_upd_id: number;


}




export class BasketProductItem{
  articoli: string;
  basketId: number;
  basketName: string;
  flg_dpl: string;
  flg_state: string;
}

export class ProductDepartment{
  basket_detail_id: number;
  code:string;
  description: string;
  flg_dpl: string;
  flg_state: string;
  host_code: string;
  id: number;
  level_no: number;
  parent_id: number;
  product_code_group_id: number;
}

export class ProductCategory{
  code: string;
  description: string;
  flg_dpl: string;
  flg_state: string;
  host_code: string;
  id: number;
  level_no: number;
  parent_id: number;
  product_code_group_id: number;
  children?: ProductCategory[]; // Opzionale, potrebbe non avere figli
  level_count: number; //serve per mantenere traccia del numero di livelli di questa categoria
  expanded: boolean; //serve per l'esplosione di categoria figlio;
}

export class Campaign3Campaign{
  budget: number;
  budget_type_id:number;
  campaign_status_description: string;
  campaign_status_id:number;
  campaign_type_description: string;
  campaign_type_id:number;
  code: string;
  description: string;
  end_date: string;
  flg_dpl: string;
  flg_kf: string;
  flg_state: string;
  id: number;
  name: string;
  priority: number;
  start_date: string;
}


export class Campaign3MessageInstance{
action_type: string;
action_type_id: number;
campaign_id: number;
campaign_name: string;
campaign_type: string;
code: string;
color: string;
end_emission_date: string;
end_fruition_date: string;
flg_dpl: string;
flg_kf: string;
flg_preview: string;
flg_rolling: string;
flg_state: string;
id: number
name:string;
promo_emission: string;
start_emission_date: string;
start_fruition_date: string;
status: string;
target_loyalty_class: string;
}

export class BudgetTypeDto{

    id: number;
    name: string;
    description: string;
    flg_state: string;
    flg_kf: string;
    flg_dpl: string;
    user_ins_id: number;
    ts_ins: string;
    user_upd_id: number;
    ts_upd: string;
    user_del_id: number;
    ts_del: string;


}

export class ActionDto{
  id: number;
  name: string;
  code: string;
  action_type: string;
  action_type_id: number;
  campaign_id: number;
  campaign_name: string;
  campaign_type: string;
  color: string;
  end_emission_date: string;
  end_fruition_date: string;
  flg_dpl: string;
  flg_kf: string;
  flg_preview: string;
  flg_rolling: string;
  flg_state: string;
  promo_emission: string;
  start_emission_date: string;
  start_fruition_date: string;
  status: string;
  target_loyalty_class: string;
  ts_del: string;
  ts_ins: string;
  ts_upd: string;
  user_del_id: number;
  user_ins_id: number;
  user_upd_id: number;
}

export class ActionTypeDto{

  id: number;
  code: string;
  name: string;
  description: string;
  form_def: any;
  form_json: any;
  flg_state: string;
  flg_kf: string;
  flg_dpl: string;
  user_ins_id: number;
  ts_ins: string;
  user_upd_id: number
  ts_upd: string;
  user_del_id: number ;
  ts_del: string ;
}
export class CampaignTypeDto{

  id: number;
  code: string;
  description: string;
  check_impl_class: any;
  flg_state: string;
  flg_kf: string;
  flg_dpl: string;
  user_ins_id: number;
  ts_ins: string;
  user_upd_id: number;
  ts_upd: string;
  user_del_id: number ;
  ts_del: string;
}
export class MessageInstanceActionStatusDto{
  code: string;
  color: string;
  description: string;
  flg_dpl: string;
  flg_kf: string;
  flg_state: string;
  id: number;
  ts_del: string;
  ts_ins: string;
  ts_upd: string;
  user_del_id: number;
  user_ins_id: number;
  user_upd_id: number;
}

export class Campaign3Store{
  address_1: string;
  address_2: string;
  channel_loyalty_id: number;
  city: string;
  classificationDetailCode: string;
  classificationDetailDescription: string;
  code: string;
  country_id: number;
  couponing_id: number;
  customer_id: number;
  date_end: string;
  date_start: string;
  description: string;
  divisionId: number;
  division_sales_network_id: number;
  flg_campaign_candidate: string;
  flg_dpl: string;
  flg_graphical_printer: string;
  flg_kf: string;
  flg_state: string;
  host_code: string;
  id: number;
  name: string;
  promotion_id: number;
  province_id: number;
  salesNetworkCode: string;
  salesNetworkDescription: string;
  salesNetworkId: string;
  salesNetworkName: string;
  short_name: string;
  state_id: number;
  rowSelected: boolean;
}


export class Touchpoint{

  code:string;
  description: string;
  flg_dpl: string;
  default_layout: string;
  flg_kf: string;
  flg_offline: string;
  flg_state: string;
  form_schema: any;
  form_values: any;
  layout_id: number;
  certifier: string; //"Yes" oppure "No" touchpoint certificatore
  certified: string; //"Yes" oppure "No" touchpoint che ha certificato, verrà calcolato dalla UI
  ochannel_id: number;
  ochannel_type_pid: number;
  wizardList: Array<Campaign3Wizard>;
  constructor(){
    this.wizardList = new Array<Campaign3Wizard>();
  }
}


export class Campaign3Status {
  number: number;
  code: string;
  statusToSave: string;
  flgPreview: string;
  flgDpl: string;

  constructor(num: number, code:string,statusToSave: string,flgPreview: string,flgDpl: string){
    this.number = num;
    this.code = code;
    this.statusToSave = statusToSave;
    this.flgPreview = flgPreview;
    this.flgDpl = flgDpl;
  }
}

export class Campaign3StatusMapping{

    //tabs
    infoBase: Campaign3Status;
    planning: Campaign3Status;
    actionTypes: Campaign3Status;
    emissionConditions: Campaign3Status;
    fruitionConditions: Campaign3Status;
    customerTarget: Campaign3Status;
    productsTarget: Campaign3Status;
    touchpoints: Campaign3Status;
    validations: Campaign3Status;

    //altri stati
    completaPreview: Campaign3Status;
    inGenerazione: Campaign3Status;
    generataInPreview: Campaign3Status;
    pubblicazioneInInvio: Campaign3Status;
    richiestaPubblicazione: Campaign3Status;
    pubblicata: Campaign3Status;
    generazioneInErrore: Campaign3Status;
    pubblicazioneRifiutata: Campaign3Status;
    pubblicazioneAnnullata: Campaign3Status;

    constructor(par: string) {
      if (par === "MSG") {

          // stati tabs
          this.infoBase = new Campaign3Status(1, "1", "1", "9", "0");
          this.planning = new Campaign3Status(2, "2", "2", "9", "0");
          this.actionTypes = new Campaign3Status(3, "3", "3", "9", "0");
          this.emissionConditions = new Campaign3Status(4, "4", "4", "9", "0");
          this.customerTarget = new Campaign3Status(5, "5", "5", "9", "0");
          this.productsTarget = new Campaign3Status(6, "6", "6", "9", "0");
          this.touchpoints = new Campaign3Status(7, "7", "7", "9", "0");
          this.validations = new Campaign3Status(8, "8", "8", "9", "0");
          //attenzione ho cambiato gli id
          // altri stati dopo aver definito i tabs
          this.completaPreview = new Campaign3Status(10, "0", "0", "1", "0");
          this.inGenerazione = new Campaign3Status(11, "R", "0", "1", "R");
          this.generataInPreview = new Campaign3Status(12, "G", "0", "1", "G");
          this.pubblicazioneInInvio = new Campaign3Status(13, "S", "0", "0", "S");
          this.richiestaPubblicazione = new Campaign3Status(14, "Q", "0", "0", "Q");
          //status to save 0->P reeditable
          this.pubblicata = new Campaign3Status(15, "P", "P", "0", "0");
          this.generazioneInErrore = new Campaign3Status(16, "E", "0", "1", "E");
          this.pubblicazioneRifiutata = new Campaign3Status(17, "X", "0", "1", "1");
          this.pubblicazioneAnnullata = new Campaign3Status(18, "U", "0", "0", "0");
      } else if (par === "CPN") {
          // stati tabs
          this.infoBase = new Campaign3Status(1, "1", "1", "9", "0");
          this.planning = new Campaign3Status(2, "2", "2", "9", "0");
          this.actionTypes = new Campaign3Status(3, "3", "3", "9", "0");
          this.emissionConditions = new Campaign3Status(4, "4", "4", "9", "0");
          this.fruitionConditions = new Campaign3Status(5, "5", "5", "9", "0");
          this.customerTarget = new Campaign3Status(6, "6", "6", "9", "0");
          this.productsTarget = new Campaign3Status(7, "7", "7", "9", "0");
          this.touchpoints = new Campaign3Status(8, "8", "8", "9", "0");
          this.validations = new Campaign3Status(9, "9", "9", "9", "0");

          // altri stati dopo aver definito i tabs
          this.completaPreview = new Campaign3Status(10, "0", "0", "1", "0");
          this.inGenerazione = new Campaign3Status(11, "R", "0", "1", "R");
          this.generataInPreview = new Campaign3Status(12, "G", "0", "1", "G");
          this.pubblicazioneInInvio = new Campaign3Status(13, "S", "0", "0", "S");
          this.richiestaPubblicazione = new Campaign3Status(14, "Q", "0", "0", "Q");
                   //status to save 0->P reeditable
          this.pubblicata = new Campaign3Status(15, "P", "P", "0", "0");
          this.generazioneInErrore = new Campaign3Status(16, "E", "0", "1", "E");
          this.pubblicazioneRifiutata = new Campaign3Status(17, "X", "0", "1", "1");
          this.pubblicazioneAnnullata = new Campaign3Status(18, "U", "0", "0", "0");
      }
  }

}



export class Campaign3ActionStatus{
  code:string;
  color: string;
  description: string;
  flg_dpl: string;
  flg_kf: string;
  flg_state: string;
  id: number;
}

export class CalculateFruitionDateRequest{
  flg_rolling: string;
  start_fruition_date: string;
  end_fruition_date: string;
  coupon_validity_date_start_mode:string;
  coupon_validity_date_start:string;
  coupon_validity_start_offset_day: number;
  coupon_validity_start_week_day:any;
  coupon_validity_date_end_mode: string;
  coupon_validity_date_end:string;
  coupon_validity_end_offset_day:number;
  coupon_validity_end_week_day:any;
  id: number;
  end_emission_date: string;
  start_emission_date:string;
  campaign_id: number
}

export class CalculateFruitionDateResponse{
  fruition_date_start: string;
  fruition_date_end: string;
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/models/campaign-3.model.ts